import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const StandardCubicFootPerStockTankBarrel: ConvertableUnit = {
  label: "SCF/STB",
  toStandardUnit: scfstb => scfstb,
  toThisUnit: scfstb => scfstb
};

export const CubicMetersPerCubicMeter: ConvertableUnit = {
  label: "m3/m3",
  toStandardUnit: m3m3 => m3m3 / 0.17810760667903525,
  toThisUnit: scfstb => scfstb * 0.17810760667903525
};

const unitList = [
  StandardCubicFootPerStockTankBarrel,
  CubicMetersPerCubicMeter
];
export const LiquidRatioUnits = {
  StandardCubicFootPerStockTankBarrel,
  CubicMetersPerCubicMeter,
  options: buildOptions(unitList)
};
